import sendCertificationStreamInfo from "./sendCertificationStreamInfo";
import sendDataStreamInfo from "./sendDataStreamInfo";

// event-logger
import logEvent from "event-logger/logEvent";

// utils
import unixTimestampInSeconds from "utils/unixTimestampInSeconds";

// A ---------------------------------------------------------------------- M

const genInfoRecord = async (isPublic, userID, keypair, dataBody, databoxID) => {
  const timestamp = unixTimestampInSeconds();

  try {
    if (databoxID) {
      // Certification stream
      const dataCertification = await sendCertificationStreamInfo(keypair, dataBody, timestamp, databoxID);

      if (!dataCertification.txid) {
        // Log certification error
        await logEvent(
          databoxID,
          "certification_error",
          timestamp,
          "Certification stream failed for info record.",
          {
            dataType: "info",
            errorMessage: "Missing txid in certification stream.",
            certificationStatus: false,
          },
          userID
        );

        console.error("Error in genInfoRecord: missing txid");

        return {
          success: false,
          error: "Error in genInfoRecord: missing txid",
        };
      }

      // Data stream
      const result = await sendDataStreamInfo(isPublic, userID, dataBody, dataCertification, timestamp, databoxID);

      if (!result.success) {
        // Log data stream error
        await logEvent(
          databoxID,
          "certification_error",
          timestamp,
          "Data stream failed for info record.",
          {
            certificationID: dataCertification.txid,
            dataType: "info",
            errorMessage: result.error,
            certificationStatus: false,
          },
          userID
        );
      } else {
        await logEvent(
          databoxID,
          "certification",
          timestamp,
          "Certification successfully performed for info record.",
          {
            certificationID: dataCertification.txid,
            dataType: "info",
            certificationStatus: true,
          },
          userID
        );
      }

      console.log(result);
      return result;
    } else {
      // Certification stream
      const dataCertification = await sendCertificationStreamInfo(keypair, dataBody, timestamp);

      if (!dataCertification.txid) {
        console.error("Error in genInfoRecord: missing txid");
        return {
          success: false,
          error: "Error in genInfoRecord: missing txid",
        };
      }

      // Data stream
      const result = await sendDataStreamInfo(isPublic, userID, dataBody, dataCertification, timestamp);
      console.log(result);
      return result;
    }
  } catch (error) {
    console.error("Error in genInfoRecord:", error);

    if (databoxID) {
      // Log a generic error for the databox
      await logEvent(
        databoxID,
        "certification_error",
        timestamp,
        "An unexpected error occurred during the record certification process.",
        {
          dataType: "info",
          errorMessage: error.message,
          certificationStatus: false,
        },
        userID
      );
    }

    const result = {
      success: false,
      error: error.message,
    };

    console.log(result);

    return result;
  }
};

export default genInfoRecord;
